import React, { useState } from 'react';
import Footer from '../../../components/Footer';
import VegIcon from '../../../components/VegIcon';
import OffersRenderer from '../../../components/OffersRenderer';
import './BohoBliss.css';

import DEFAULT_LOGO from '../../../assets/defaults/logo-default.jpg';
import DEFAULT_ITEM from '../../../assets/defaults/item-default.jpg';
import MenuItemImage from '../../../components/MenuItemImage';
import RestaurantLogo from '../../../components/RestaurantLogo';

const BohoBliss = ({ data }) => {
    const restaurant = data?.restaurant || {};
    const menus = data?.menus || [];
    const [activeMenuId, setActiveMenuId] = useState(menus[0]?.id);
    const [selectedItem, setSelectedItem] = useState(null);

    const activeMenu = menus.find(m => m.id === activeMenuId) || menus[0];

    if (!data) return <div className="boho-loading">Planting seeds...</div>;

    return (
        <div className="boho-root">
            <div className="boho-blob-1"></div>
            <div className="boho-blob-2"></div>

            {/* RESTAURANT HEADER */}
            <header className="boho-header">
                <div className="boho-logo-ring">
                    <RestaurantLogo src={restaurant.logoUrl} className="boho-logo" />
                </div>
                <h1 className="boho-title" title={restaurant.name}>{restaurant.name || 'Boho Bliss'}</h1>
                <p className="boho-bio" title={restaurant.description}>{restaurant.description || 'Natural flavors, artistic vibes, and happy souls.'}</p>
                <div className="boho-info">
                    {restaurant.address && <span>{restaurant.address}</span>}
                </div>
            </header>

            {/* Offers / Notes */}
            <OffersRenderer offers={data?.offers} />

            {/* CATEGORY NAVIGATION */}
            {menus.length > 1 && (
                <div className="boho-nav-pill-container">
                    <nav className="boho-nav">
                        {menus.map(menu => (
                            <button
                                key={menu.id}
                                className={`boho-nav-item ${activeMenuId === menu.id ? 'active' : ''}`}
                                onClick={() => setActiveMenuId(menu.id)}
                            >
                                {menu.name}
                            </button>
                        ))}
                    </nav>
                </div>
            )}

            {/* MENU CATEGORIES & ITEMS */}
            <main className="boho-main">
                {activeMenu && activeMenu.categories?.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0)).map(cat => (
                    <section key={cat.id} className="boho-category">
                        <div className="boho-cat-header">
                            <span className="boho-cat-flower">✻</span>
                            <h2>{cat.name}</h2>
                            <span className="boho-cat-flower">✻</span>
                        </div>
                        <div className="boho-items">
                            {cat.items?.map(item => (
                                <BohoItem key={item.id} item={item} onClick={() => setSelectedItem(item)} />
                            ))}
                        </div>
                    </section>
                ))}
            </main>

            {/* MENU ITEM DETAIL MODAL */}
            {selectedItem && (
                <div className="boho-modal-overlay" onClick={() => setSelectedItem(null)}>
                    <div className="boho-modal" onClick={e => e.stopPropagation()}>
                        <button className="boho-modal-close" onClick={() => setSelectedItem(null)}><strong>✕</strong></button>
                        <div className="boho-modal-img">
                            <MenuItemImage
                                src={selectedItem.imageUrl}
                                alt={selectedItem.name}
                            />
                        </div>
                        <div className="boho-modal-body">
                            <h3>{selectedItem.name}</h3>
                            {Number(selectedItem.price) > 0 && (
                                <p className="boho-modal-price">₹{Number(selectedItem.price).toLocaleString()}</p>
                            )}
                            <p className="boho-modal-desc">{selectedItem.description}</p>

                            {
                                selectedItem.variants && selectedItem.variants.length > 0 ? <div className="boho-modal-variants">
                                <h4>Variants</h4>
                                {selectedItem.variants?.filter(v => v.isActive).map(v => (
                                    <div key={v.id} className="boho-v-row">
                                        <span>{v.name}</span>
                                        <span className="boho-v-price">
                                            {Number(v.price) > 0 ? `₹${Number(v.price).toLocaleString()}` : ''}
                                        </span>
                                    </div>
                                ))}
                            </div> : null
                            }
                            
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

const BohoItem = ({ item, onClick }) => {
    if (!item) return null;

    return (
        <div className={`boho-item-card ${!item.isAvailable ? 'unavailable' : ''}`} onClick={onClick} style={{ cursor: 'pointer' }}>
            <div className="boho-item-visual">
                <MenuItemImage
                    src={item.imageUrl}
                    alt={item.name}
                    className="boho-item-img"
                />
                {Number(item.price) > 0 && (
                    <div className="boho-price-circle">₹{Number(item.price).toLocaleString()}</div>
                )}
            </div>

            <div className="boho-item-content">
                <div className="boho-item-top">
                    <div className="boho-title-group">
                        {(item.isVeg !== undefined && item.isVeg !== null) && (
                            <span className={`boho-veg-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
                                <span className="boho-veg-dot"></span>
                            </span>
                        )}
                        <h3 className="boho-item-name" title={item.name}>{item.name}</h3>
                    </div>
                </div>

                <p className="boho-item-desc" title={item.description}>{item.description}</p>

                {item.tags && (
                    <div className="boho-item-tags">
                        {item.tags.map(t => <span key={t} className="boho-item-tag">#{t.toLowerCase()}</span>)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BohoBliss;
